import { Stack, TableCell, TableHead, TableRow } from "@mui/material";
import { ReactComponent as IconWorkout } from "assets/images/icons/workout.svg";
import { ReactComponent as EditIcon } from "assets/images/square-buttons/edit-line.svg";
import { ReactComponent as ViewIcon } from "assets/images/square-buttons/more.svg";
import { ReactComponent as TrashIcon } from "assets/images/square-buttons/squared-trash.svg";
import { ReactComponent as CloseIcon } from "assets/images/toggle-checkboxes/circle/close-red.svg";
import { ReactComponent as CheckIcon } from "assets/images/toggle-checkboxes/circle/on-normal.svg";
import Tooltip from "components/Tooltip";
import SortButton from "containers/Members/SortButton";
import { stringToColor } from "helpers/utils";
import { useNavigate } from "react-router-dom";

export const TableHeader = ({ sortingCallback, pageParams }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell align="left"></TableCell>
        <TableCell align="left">
          <SortButton
            label="Template Name"
            value="NAME"
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="center">Cardio Program</TableCell>
        <TableCell align="center">Flexibility Program </TableCell>
        <TableCell align="center">Strength Program</TableCell>
        <TableCell align="right">Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export const TableItem = ({ data, index, editCallback, deleteCallback }) => {
  const navigate = useNavigate();

  return (
    <TableRow key={`row${index}`}>
      <TableCell align="left">
        <Stack direction={"row"} alignItems="center">
          <span
            style={{ backgroundColor: stringToColor(data.name) }}
            className={"rounded-circle member-icon"}
          >
            <IconWorkout width={24} height={24} />
          </span>
        </Stack>
      </TableCell>
      <TableCell align="left" className="bold black" width="20%">
        {data.name}
      </TableCell>
      <TableCell align="center" width="20%">
        {data.has_cardio_workouts ? <CheckIcon /> : <CloseIcon />}
      </TableCell>
      <TableCell align="center" width="20%">
        {data.has_stretch_workouts ? <CheckIcon /> : <CloseIcon />}
      </TableCell>
      <TableCell align="center" width="20%">
        {data.has_strength_workouts ? <CheckIcon /> : <CloseIcon />}
      </TableCell>
      <TableCell align="right" width="20%">
        <div className={"buttons-bar"}>
          <Tooltip content={"Trash"} direction="bottom">
            <button onClick={() => deleteCallback(data.id)}>
              <TrashIcon />
            </button>
          </Tooltip>
          <Tooltip content={"Edit"} direction="bottom">
            <button onClick={() => editCallback(data.id)}>
              <EditIcon />
            </button>
          </Tooltip>
          <Tooltip content={"View"} direction="bottom">
            <button onClick={() => navigate(`/workout-templates/template/${data.id}`)}>
              <ViewIcon />
            </button>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  );
};
